import { jsx } from "react/jsx-runtime";
import { List } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import { usePlacement } from "../../components/PlacementProvider/PlacementProvider.esm.js";
import makeContentInteractive from "../../util/makeSpansInteractive.esm.js";
const getExtraInstructions = (isPost) => [{
  shouldProcessNode(node) {
    return node.name === "ul" || node.name === "ol";
  },
  processNode(node, children, nodeIndex) {
    var _a;
    const isNestedList = ((_a = node.parentNode) == null ? void 0 : _a.name) === "li";
    return /* @__PURE__ */ jsx(List, { attrs: node.attributes, appearance: node.name === "ol" ? "number" : "bullet", ...isPost && !isNestedList && {
      paddingBottom: "sm"
    }, children }, `${nodeIndex}-list-${node.name}`);
  }
}, {
  shouldProcessNode(node) {
    return node.name === "li";
  },
  processNode(node, children, nodeIndex) {
    return /* @__PURE__ */ jsx(List.Item, { style: {
      listStyleType: "inherit"
    }, children }, `${nodeIndex}-listitem-${node.name}`);
  }
}];
const WPList = ({
  innerHTML
}) => {
  const isPost = usePlacement() === "post";
  const parsedComponent = makeContentInteractive(innerHTML, {
    extraInstructions: getExtraInstructions(isPost)
  });
  return parsedComponent;
};
WPList.propTypes = {
  index: PropTypes.number,
  innerHTML: PropTypes.string
};
export {
  WPList as default
};
